import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-spy-icon',
  templateUrl: './code-spy.component.html'
})
export class CodeSpyComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
